import store from '@state/store';
let GoogleAuth;
const { gapi } = window;
const {
  VUE_APP_PEOPLE_KEY: peopleApiKey,
  VUE_APP_PEOPLE_CLIENT_ID: peopleClientId,
} = process.env;

export default async function getGoogleContacts() {
  // Load the API client and auth2 library
  const load = new Promise(function(resolve, reject) {
    gapi.load('client:auth2', resolve);
  });
  return load.then(async () => {
    await initClient();
  });
}

async function initClient() {
  try {
    // initialize the JS client library
    await gapi.client.init({
      apiKey: peopleApiKey,
      clientId: peopleClientId,
      discoveryDocs: ['https://people.googleapis.com/$discovery/rest'],
      // scope is a space delimited string
      scope: 'https://www.googleapis.com/auth/contacts.readonly',
    });
    GoogleAuth = await gapi.auth2.getAuthInstance();

    // Listen for sign-in state changes.
    GoogleAuth.isSignedIn.listen(
      await updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get())
    );
  } catch (error) {
    console.error(error);
  }
}

/**
 * Listener called when user completes auth flow. If the currentApiRequest
 * variable is set, then the user was prompted to authorize the application
 * before the request executed. In that case, proceed with that API request.
 */
async function updateSigninStatus(isSignedIn) {
  if (isSignedIn) {
    await makeApiCall();
  } else {
    await GoogleAuth.signIn();
    await updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
  }
}

async function makeApiCall() {
  try {
    // https://developers.google.com/people/api/rest/v1/people.connections/list
    const response = await gapi.client.people.people.connections.list({
      resourceName: 'people/me', // deprecated (required for now)
      personFields: 'emailAddresses,names,phoneNumbers',
    });
    await formatResults(response.result.connections);
  } catch (error) {
    return error.result.error.message;
  }
}

// [{name: '', email: [], phone: []}] that is the format we want!
async function formatResults(arrayComingFromPeopleApi) {
  const resources = arrayComingFromPeopleApi.map((resource) => {
    // get multiple email addresses and phone numbers if applicable
    const { emailAddresses = [], names = [], phoneNumbers = [] } = resource;
    const email = emailAddresses.map((email = {}) => email.value || '');
    const phone = phoneNumbers.map((phone = {}) => phone.value || '');
    const lastName = names.map((name = {}) => name.familyName || '');
    const firstName = names.map((name = {}) => name.givenName || '');

    return {
      first: firstName[0],
      last: lastName[0],
      email,
      phone,
    };
  });
  await store.commit('prospect/setInitialImport', true);
  await store.dispatch('prospect/verifyProspects', resources);
}
